var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Row, Col } from "react-bootstrap";
import { isSafeInteger, get } from "lodash";
import { Hr } from "@irati/ui/src/Layout";
import { FormattedMessage } from "@irati/utils/lang";
import { H4 } from "@irati/ui/src/Typography";
import withBasket from "@irati/checkout/utils/basket/withBasket";
import { Subtotal, ProductList, SelectedEmail, VAT } from "./CommonElements";
import Total from "./Total";
var OrderSummary = /** @class */ (function (_super) {
    __extends(OrderSummary, _super);
    function OrderSummary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.calculateTotals = function () {
            var _a, _b, _c;
            var _d = _this.props, walletBalanceToUse = _d.walletBalanceToUse, basket = _d.basket;
            var breakdown = basket.breakdown;
            if (!breakdown) {
                return {};
            }
            var currency = breakdown.total.currency;
            var subtotal = breakdown.total.amount + breakdown.total.serviceCharge;
            var discount = breakdown.total.originalPrice - subtotal;
            var total = subtotal - (walletBalanceToUse || 0);
            var vat = breakdown.total.vat;
            var isOpenValue = isSafeInteger((_b = (_a = breakdown.items[0]) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.openValue);
            return {
                vat: vat,
                total: total,
                discount: discount,
                subtotal: subtotal,
                currency: currency,
                isOpenValue: isOpenValue,
                hasSelectedAProduct: (((_c = _this.props.basket.items) === null || _c === void 0 ? void 0 : _c.length) || 0) !== 0
            };
        };
        return _this;
    }
    OrderSummary.prototype.render = function () {
        var _a = this.props, deal = _a.deal, email = _a.email, walletBalanceToUse = _a.walletBalanceToUse, basket = _a.basket;
        var breakdown = basket.breakdown;
        var _b = this.calculateTotals(), vat = _b.vat, total = _b.total, discount = _b.discount, subtotal = _b.subtotal, currency = _b.currency, isOpenValue = _b.isOpenValue, hasSelectedAProduct = _b.hasSelectedAProduct;
        var products = get(deal, "productConfig.products", []);
        return (React.createElement("div", { className: "orderSummary" },
            React.createElement(Row, null,
                React.createElement(Col, { md: 12 },
                    React.createElement(H4, { marginTop: 3, overflowWrap: "break-word" }, deal.header),
                    React.createElement(Hr, null),
                    email && deal.emailRequired && React.createElement(SelectedEmail, { email: email }),
                    isOpenValue && subtotal === 0 && React.createElement(FormattedMessage, { id: "perks.orderSummary.openValue.noAmountEntered" }),
                    hasSelectedAProduct && React.createElement(ProductList, { data: products, breakdown: breakdown }),
                    ((!!discount && discount > 0) || (!!walletBalanceToUse && walletBalanceToUse > 0)) && (React.createElement(Subtotal, { subtotal: subtotal, discount: discount, walletBalanceToUse: walletBalanceToUse, currency: currency })),
                    ((!!total && total > 0) || (!!walletBalanceToUse && walletBalanceToUse > 0)) && (React.createElement("div", null,
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(VAT, { net: total, vat: vat, currency: currency }))),
                        React.createElement(Total, { total: total, currency: currency })))))));
    };
    OrderSummary.defaultProps = {
        email: "",
        walletBalanceToUse: 0
    };
    return OrderSummary;
}(PureComponent));
export default withBasket(OrderSummary);
